import { AddonProduct, ServicePackageType } from '@/api/Cart/cart.interfaces';
import { getAddonTitle } from '@/helpers/addon';
import { t } from '@shared/helpers/translation';

export const mapAddonLabel = (product: AddonProduct): string => {
    if ('Ordinal' in product && product.Ordinal) {
        switch (product.Ordinal) {
            case ServicePackageType.Basic:
                return t({ key: 'service_package.basic_service_package' });
            case ServicePackageType.Premium:
                return t({ key: 'service_package.premium_service_package' });
            default:
                return '';
        }
    }
    const title = getAddonTitle(product.$type);
    return title !== '' ? title : product.Description;
};
